module.exports = __webpack_public_path__ + "static/img/vacuumTechnical.e811ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/vacuumTechnical.png
// module id = EZab
// module chunks = 1